import React, { useCallback, useEffect, useState } from 'react';
import axios from '../api/axiosInstance';
import './AdminEquipmentProfileSlideOut.css';
import { QRCodeSVG } from 'qrcode.react';
import odinLogo from '../assets/ODIN_Logo_No_BG-01.png';
import { apiFileUrl } from '../config/runtimeConfig';

const COVERED_PROCESS_OPTIONS = [
  'BMP',
  'EPN',
  'PSM',
  'RMP',
  'SARA 302',
  'SARA 312',
  'SARA 313',
  'SPC',
  'SPCC',
  'SRPV',
  'Hazard Contents (EPA/NFPA)',
  'Kraft Liquor Cycle',
];
 const ACTION_ITEM_TYPE = [
  'Calculations',
  'Housekeeping',
  'NDE Follow Up',
  'Update',
  'Repair/Replace',
  'Inspection Prep',
 ];

 const ACTION_ITEM_CATEGORY = [
  'Capital',
  'Environmental',
  'Maintenance',
  'Mechanical Integrity',
  'Safety',
  'Program Management',
 ];

 const NEXT_INSPECTION_FIELDS = [
  { label: 'Next Internal Inspection', dateKey: 'nextInternalInspection', overrideKey: 'nextInternalOverride' },
  { label: 'Next External Inspection', dateKey: 'nextExternalInspection', overrideKey: 'nextExternalOverride' },
  { label: 'Next UT Inspection',       dateKey: 'nextUtInspection',       overrideKey: 'nextUtOverride' },
];

const OVERRIDE_PRESETS = ['EXEMPT', 'N/A', 'As Available', 'No Data', 'CUSTOM'];


 const DESIGN_INFO_FIELDS = [
  { key: 'floor', label: 'Floor' },
  { key: 'equipmentIndoors', label: 'Equipment Indoors', type: 'boolean' },
  { key: 'manufacturer', label: 'Manufacturer' },
  { key: 'printNumber', label: 'Print Number' },
  { key: 'constructionDate', label: 'Construction Date' },
  { key: 'constructionCode', label: 'Construction Code' },
  { key: 'serialNumber', label: 'Serial Number' },
  { key: 'nationalBoardNumber', label: 'National Board Number' },
  { key: 'contents', label: 'Contents' },
  { key: 'specificGravity', label: 'Specific Gravity' },
  { key: 'capacity', label: 'Capacity' },
  { key: 'designTemperature', label: 'Design Temperature' },
  { key: 'operatingTemperature', label: 'Operating Temperature' },
  { key: 'designPSIG', label: 'Design PSIG' },
  { key: 'operatingPSIG', label: 'Operating PSIG' },
  { key: 'mawp', label: 'MAWP' },
  { key: 'insulation', label: 'Insulation' },
  { key: 'exteriorCoating', label: 'Exterior Coating' },
  { key: 'jointEfficiency', label: 'Joint Efficiency' },
  { key: 'lining', label: 'Lining' },
  { key: 'corrosionAllowance', label: 'Corrosion Allowance' },
  { key: 'phOfProduct', label: 'pH of Product' },
  { key: 'foundation', label: 'Foundation' },
  { key: 'materialSpecification', label: 'Material Specification' },
  { key: 'diameter', label: 'Diameter' },
  { key: 'length', label: 'Length' },
  { key: 'width', label: 'Width' },
  { key: 'height', label: 'Height' },
  { key: 'heightOverflow', label: 'Height Overflow' },
  // photoPath is handled separately by your uploader/preview
];

const resolveFileUrl = apiFileUrl;


  const EXCLUDED_KEYS = new Set([
  'id', 'equipmentId', 'areaId',
  'nextInternalInspection', 'nextExternalInspection', 'nextUtInspection',
  'nextInternalOverride', 'nextExternalOverride', 'nextUtOverride',
]);


const AdminEquipmentProfileSlideOut = ({ isOpen, onClose, equipmentId, areas = [] }) => {
  const [profile, setProfile] = useState(null);
  const [expandedImage, setExpandedImage] = useState(null);
  const [designDocuments, setDesignDocuments] = useState([]);
  const [ventOverflowDocuments, setVentOverflowDocuments] = useState([]);
  const [inspectionProtocolDocuments, setInspectionProtocolDocuments] = useState([]);
  const [tminDocuments, setTminDocuments] = useState([]);
  const [inspectionRecordDocuments, setInspectionRecordDocuments] = useState([]);
  const [isUploadingRecDocs, setIsUploadingRecDocs] = useState(false);
  const [additionalPhotos, setAdditionalPhotos] = useState([]);
  const [editingRecord, setEditingRecord] = useState(null);
  const [newRecord, setNewRecord] = useState({ date: '', company: '', inspector: '', type: '', jobScope: '', status: '' });
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [editingActionItem, setEditingActionItem] = useState(null);
  const [showValveModal, setShowValveModal] = useState(false);
const [editingValve, setEditingValve] = useState(null);
const [valveDocNameDrafts, setValveDocNameDrafts] = useState({}); // { [docId]: "draft name" }
const [isSavingValveDocName, setIsSavingValveDocName] = useState(false);
const [showValveDocsUploadModal, setShowValveDocsUploadModal] = useState(false);
const [pendingValveDocs, setPendingValveDocs] = useState([]); 
// [{ key, file, displayName }]
const [isUploadingValveDocs, setIsUploadingValveDocs] = useState(false);


const EMPTY_VALVE = {
  id: null,
  equipmentId: equipmentId,
  valveTagNumber: '',
  valveLocation: '',
  sapNumber: '',
  setPressure: '',
  testFrequency: '',
  lastTestDate: '',
  nextTestDate: '',
  lastRepairReplacement: '',
  nextRepairReplacement: '',
  repairFrequency: '',
  size: '',
  requiredCapacity: '',
  valveCapacity: '',
  contents: '',
  type: '',
  manufacturer: '',
  modelNumber: '',
  serialNumber: '',
  flangePressureRating: '',
  valveNotes: '',
  photoPath: ''
};

 const EMPTY_COSTS = {
  id: 0,
  inspectionCost: '',
  scaffoldCost: '',
  cleaningCost: '',
  repairCost: '',
  notes: ''
};
  
const [inspectionCost, setInspectionCost] = useState(EMPTY_COSTS);
const [valveForm, setValveForm] = useState(EMPTY_VALVE);

  const [newActionItem, setNewActionItem] = useState({
    dueDate: '',
    actionText: '',
    category: '',
    type: '',
    priority: '',
    status: '',
    notes: '',
    completed: false
  });
  const [showActionItemModal, setShowActionItemModal] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState('details'); // 'details' | 'costs'
  const [savedRecordId, setSavedRecordId] = useState(null);
  const INSPECTION_TYPES = ['Internal', 'External', 'UT', 'Internal/External', 'Internal/UT', 'External/UT', 'Internal/External/UT'];
  

  

  const refreshProfile = useCallback(async () => {
    try {
      const response = await axios.get(`/api/equipment/${equipmentId}/profile`);
      setProfile(response.data);
      return response.data;
    } catch (err) {
      console.error('Error fetching profile:', err);
      return null;
    }
  }, [equipmentId]);

  useEffect(() => {
    if (equipmentId && isOpen) {
      refreshProfile();
    }
  }, [equipmentId, isOpen, refreshProfile]);

  const buildRecordPayload = (r) => ({
  date: r.date || null,
  company: r.company || '',
  inspector: r.inspector || '',
  type: r.type || '',
  jobScope: r.jobScope || '',
  status: r.status || ''
});

  const formatLabel = (label) => {
    return label.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  };

  const handleInputChange = (section, key, value) => {
    setProfile((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value,
      },
    }));
  };


  const setNextInspectionMode = (dateKey, overrideKey, mode) => {
  setProfile(prev => {
    const ed = prev?.equipmentDescription || {};
    if (mode === 'override') {
      return {
        ...prev,
        equipmentDescription: {
          ...ed,
          [dateKey]: null,
          [overrideKey]: ed[overrideKey] ?? 'As Available', // default if switching to override
        }
      };
    }
    // mode === 'date'
    return {
      ...prev,
      equipmentDescription: {
        ...ed,
        [overrideKey]: null,
        [dateKey]: ed[dateKey] ?? null,
      }
    };
  });
};

const setNextInspectionDate = (dateKey, overrideKey, value) => {
  setProfile(prev => ({
    ...prev,
    equipmentDescription: {
      ...(prev?.equipmentDescription || {}),
      [dateKey]: value ? value : null,       // important: send null, not ""
      [overrideKey]: null,
    }
  }));
};

const setNextInspectionOverride = (dateKey, overrideKey, value) => {
  const cleaned = (value ?? '').trim();
  setProfile(prev => ({
    ...prev,
    equipmentDescription: {
      ...(prev?.equipmentDescription || {}),
      [overrideKey]: cleaned.length ? cleaned : null,
      [dateKey]: null,
    }
  }));
};


    const handleCoveredProcessToggle = (processName, checked) => {
    setProfile((prev) => {
      if (!prev) return prev;
      const current = prev.coveredProcesses || [];

      if (checked) {
        // avoid duplicates
        if (current.some((p) => p.processName === processName)) {
          return prev;
        }
        return {
          ...prev,
          coveredProcesses: [...current, { processName }],
        };
      } else {
        // remove unchecked one
        return {
          ...prev,
          coveredProcesses: current.filter((p) => p.processName !== processName),
        };
      }
    });
  };


  const handleProfileUpdate = async () => {
    try {
      await axios.put(`/api/equipment/${equipmentId}/profile`, profile);
      alert('Profile updated successfully');
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile');
    }
  };

  const [isSavingRecord, setIsSavingRecord] = useState(false);

  const handleCostsTabClick = async () => {
    // already on costs? do nothing
    if (activeModalTab === 'costs') return;
  
    // if we already have an id, just switch
    if (editingRecord?.id || savedRecordId) {
      setActiveModalTab('costs');
      return;
    }
  
    // otherwise, create/update once, then switch
    try {
      const { id } = await saveRecordDetails();
      if (id) setActiveModalTab('costs');
    } catch {
      // saveRecordDetails already alerts on failure
    }
  };


  const currentRecordId = () => {
    const raw = savedRecordId ?? editingRecord?.id ?? null;
    return (raw && typeof raw === 'object') ? raw.id : raw;
  };

  const docsForCurrentRecord = (rid) =>
    rid
      ? (profile?.inspectionRecordDocuments || []).filter(
          (d) => String(d.inspectionRecordId) === String(rid)
        )
      : [];

const handleDocumentsTabClick = async () => {
  if (activeModalTab === 'documents') return;
  if (currentRecordId()) { setActiveModalTab('documents'); return; }
  try {
    const { id } = await saveRecordDetails();
    if (id) setActiveModalTab('documents');
  } catch {/* saveRecordDetails already handles errors */}
};



// --- Helpers to prevent "massive URL" bug ---
const normalizeId = (v) => {
  if (v == null) return null;
  if (typeof v === 'object') v = v.id ?? null;
  const s = String(v ?? '').trim();
  return /^\d+$/.test(s) ? s : null; // only allow numeric IDs through
};

const findCreatedRecordFromProfile = (refreshedProfile, payload) => {
  const list = refreshedProfile?.inspectionRecords || [];
  const matches = list.filter(r =>
    String(r.date ?? '') === String(payload.date ?? '') &&
    String(r.company ?? '') === String(payload.company ?? '') &&
    String(r.inspector ?? '') === String(payload.inspector ?? '') &&
    String(r.type ?? '') === String(payload.type ?? '') &&
    String(r.jobScope ?? '') === String(payload.jobScope ?? '') &&
    String(r.status ?? '') === String(payload.status ?? '')
  );

  // if multiple match (rare), use highest id
  return matches.sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))[0] || null;
};

const openNewValveModal = () => {
  setEditingValve(null);
  setValveForm({ ...EMPTY_VALVE, equipmentId });
  setShowValveModal(true);
};

const openEditValveModal = (v) => {
  setEditingValve(v);

  // seed drafts for displayName inputs
  const drafts = {};
  (v?.inspectionDocuments || []).forEach(doc => {
    if (doc?.id) drafts[doc.id] = doc.displayName ?? '';
  });
  setValveDocNameDrafts(drafts);

  setValveForm({
    ...EMPTY_VALVE,
    ...v,
    equipmentId: v.equipmentId || equipmentId,
    lastTestDate: v.lastTestDate || '',
    nextTestDate: v.nextTestDate || '',
    lastRepairReplacement: v.lastRepairReplacement || '',
    nextRepairReplacement: v.nextRepairReplacement || ''
  });
  setShowValveModal(true);
};

const openValveDocsUploadModal = (files) => {
  const list = Array.from(files || []).map((file, idx) => ({
    key: `${file.name}-${file.size}-${file.lastModified}-${idx}`,
    file,
    displayName: '' // user fills in
  }));

  setPendingValveDocs(list);
  setShowValveDocsUploadModal(true);
};

const uploadPendingValveDocs = async () => {
  if (!editingValve?.id) {
    alert('Save the valve first before uploading documents.');
    return;
  }

  if (!pendingValveDocs.length) {
    setShowValveDocsUploadModal(false);
    return;
  }

  setIsUploadingValveDocs(true);
  try {
    for (const item of pendingValveDocs) {
      const dn = (item.displayName ?? '').trim(); // allow blank
      await uploadValveInspectionDocument(item.file, editingValve.id, dn);
    }

    // Refresh and keep the modal valve in sync
    const refreshed = await refreshProfile();
    const updated = (refreshed?.valves || []).find(v => String(v.id) === String(editingValve.id));
    if (updated) {
      setEditingValve(updated);
      setValveForm(prev => ({ ...prev, ...updated }));
    }

    setPendingValveDocs([]);
    setShowValveDocsUploadModal(false);
  } catch (err) {
    console.error(err);
    alert('Failed to upload one or more valve inspection documents.');
  } finally {
    setIsUploadingValveDocs(false);
  }
};



const buildValvePayload = (v) => ({
  equipmentId: equipmentId, // keep authoritative
  valveTagNumber: v.valveTagNumber || '',
  valveLocation: v.valveLocation || '',
  sapNumber: v.sapNumber || '',
  setPressure: v.setPressure || '',
  testFrequency: v.testFrequency || '',
  lastTestDate: v.lastTestDate || null,
  nextTestDate: v.nextTestDate || null,
  lastRepairReplacement: v.lastRepairReplacement || null,
  nextRepairReplacement: v.nextRepairReplacement || null,
  repairFrequency: v.repairFrequency || '',
  size: v.size || '',
  requiredCapacity: v.requiredCapacity || '',
  valveCapacity: v.valveCapacity || '',
  contents: v.contents || '',
  type: v.type || '',
  manufacturer: v.manufacturer || '',
  modelNumber: v.modelNumber || '',
  serialNumber: v.serialNumber || '',
  flangePressureRating: v.flangePressureRating || '',
  valveNotes: v.valveNotes || '',
  photoPath: v.photoPath || null
});

const saveValve = async () => {
  if (!valveForm.valveTagNumber?.trim()) {
    alert('Valve Tag Number is required.');
    return;
  }

  try {
    const payload = buildValvePayload(valveForm);

    if (editingValve?.id) {
      await axios.put(`/api/valves/${editingValve.id}`, payload);
    } else {
      await axios.post(`/api/valves?equipmentId=${equipmentId}`, payload);
    }

    await refreshProfile();
    setShowValveModal(false);
    setEditingValve(null);
  } catch (e) {
    console.error('Failed to save valve:', e);
    alert('Failed to save valve.');
  }
};

const deleteValve = async (valveId) => {
  if (!window.confirm('Delete this valve?')) return;
  try {
    await axios.delete(`/api/valves/${valveId}`);
    await refreshProfile();
  } catch (e) {
    console.error('Failed to delete valve:', e);
    alert('Failed to delete valve.');
  }
};

const uploadValvePhoto = async (file, valveId) => {
  const formData = new FormData();
  formData.append('file', file);

  await axios.post('/api/files/upload/valvePhoto', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { valveId },
    timeout: 120000

  });

  await refreshProfile();
};

const uploadValveInspectionDocument = async (file, valveId, displayName = '') => {
  const formData = new FormData();
  formData.append('file', file);

  await axios.post('/api/files/upload/valveInspectionDocuments', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { valveId, displayName },
    timeout: 120000
  });

  await refreshProfile();
};




const uploadInspectionRecordDocs = async (files) => {
  const rid = normalizeId(editingRecord?.id ?? savedRecordId);
  if (!rid) {
    console.error('Blocked upload: invalid inspectionRecordId', { editingRecord, savedRecordId });
    alert('Please save Record Details first (valid record id not available).');
    return;
  }

  setIsUploadingRecDocs(true);
  try {
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);

      await axios.post(
        '/api/files/upload/inspectionRecordDocuments',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          params: { equipmentId: Number(equipmentId), inspectionRecordId: rid },
          timeout: 120000,
        }
      );
    }
    await refreshProfile();
  } catch (err) {
    console.error('Upload failed:', err);
    alert('Failed to upload one or more files.');
  } finally {
    setIsUploadingRecDocs(false);
  }
};



  

  const handleDeleteDoc = async (section, doc) => {
    try {
      if (!doc?.id) {
        alert('Missing document id; cannot delete safely.');
        return;
      }
      await axios.delete(`/api/files/delete/${section}/${doc.id}`);
      await refreshProfile();
    } catch (err) {
      console.error('Failed to delete file:', err);
      alert('Error deleting file');
    }
  };

  

  const handleOpenActionItemModal = () => {
    setEditingActionItem(null);
    setNewActionItem({
      dueDate: '',
      actionText: '',
      category: '',
      type: '',
      priority: '',
      status: '',
      notes: '',
      completed: false,
    });
    setShowActionItemModal(true);
  };

  const handleActionItemSubmit = async () => {
    try {
      const endpoint = editingActionItem
  ? `/api/action-items/${editingActionItem.id}`
  : `/api/action-items?equipmentId=${equipmentId}`;


      const method = editingActionItem ? axios.put : axios.post;

      await method(endpoint, { ...newActionItem, equipmentId });
      refreshProfile();
      setShowActionItemModal(false);
    } catch (error) {
      console.error('Failed to submit action item:', error);
      alert('Failed to save the action item. Please check the required fields and try again.');
    }
  };
  

  const saveRecordDetails = async () => {
  if (isSavingRecord) return { id: editingRecord?.id || savedRecordId || null, created: false };

  setIsSavingRecord(true);
  try {
    
    if (editingRecord?.id) {
      const res = await axios.put(
        `/api/inspection-records/update/${editingRecord.id}`,
        buildRecordPayload(newRecord)
      );

      const id = String(res.data?.id ?? editingRecord.id);

      const refreshed = await refreshProfile(); //  get latest profile from server
      const serverRec = refreshed?.inspectionRecords?.find(r => String(r.id) === id);

      if (serverRec) {
        setEditingRecord(serverRec);
        setNewRecord(buildRecordPayload(serverRec));
      }

      setSavedRecordId(id);
      return { id, created: false };
    }

    // CREATE
const payload = buildRecordPayload(newRecord);

// create record (ignore response shape entirely)
await axios.post(
  `/api/inspection-records/create?equipmentId=${equipmentId}`,
  payload
);

// now fetch profile and find the created record reliably
const refreshed = await refreshProfile();
const serverRec = findCreatedRecordFromProfile(refreshed, payload);

if (!serverRec?.id) {
  console.error('Record saved but could not resolve new record id from refreshed profile.', {
    payload,
    inspectionRecords: refreshed?.inspectionRecords
  });
  alert('Record saved, but could not resolve its ID. Close and reopen the record before uploading documents.');
  return { id: null, created: true };
}

setEditingRecord(serverRec);
setNewRecord(buildRecordPayload(serverRec));
setSavedRecordId(String(serverRec.id));
return { id: String(serverRec.id), created: true };


  } catch (e) {
    console.error('saveRecordDetails failed:', e);
    throw e;
  } finally {
    setIsSavingRecord(false);
  }
};

  
  
  
  const saveCosts = async () => {
    const rawId = editingRecord?.id || savedRecordId;
    if (!rawId) { alert('Please save Record Details first.'); setActiveModalTab('details'); return; }
  
    const inspectionRecordId = /^\d+$/.test(String(rawId))
      ? parseInt(String(rawId), 10)
      : String(rawId);
  
    const areaId = profile?.equipmentDescription?.areaId
      ? parseInt(profile.equipmentDescription.areaId, 10)
      : null;
    if (!areaId) { alert('Please select an Area on the record before saving costs.'); setActiveModalTab('details'); return; }
  
    const payload = {
      equipmentId,
      inspectionRecordId,
      areaId,
      inspectionCost: inspectionCost.inspectionCost || 0,
      scaffoldCost: inspectionCost.scaffoldCost || 0,
      cleaningCost: inspectionCost.cleaningCost || 0,
      repairCost: inspectionCost.repairCost || 0,
      notes: inspectionCost.notes || ''
    };
    if (inspectionCost.id && inspectionCost.id > 0) payload.id = inspectionCost.id;
  
    await axios.post('/api/inspection-costs', payload);
    await refreshProfile();
    setShowRecordModal(false);
  };
  
  
  const handleSaveClick = async () => {
    try {
      if (activeModalTab === 'details') {
        await saveRecordDetails();
        // optional: automatically move to Costs after first save
        // if (!editingRecord?.id && savedRecordId) setActiveModalTab('costs');
      } else {
        await saveCosts();
      }
    } catch (e) {
      console.error('Save failed:', e);
      alert('Save failed. Please try again.');
    }
  };
  



  const handleQrDownload = async () => {
    const svgEl = document.getElementById('equipment-qr');
    if (!svgEl) return;
  
    const qrSvg = svgEl.outerHTML;
    const name = profile?.equipmentDescription?.equipmentName || 'equipment-qr';
  
    // --- Layout constants (tune as needed) ---
    const qrSize = 190;
    const nameFontSize = 32;
    const nameMaxWidth = 340; // increase if you want longer names before wrapping
    const nameLineHeight = 1.1;
    const logoWidth = 320; // try to match nameMaxWidth or smaller
    const logoHeight = 96; // adjust for your logo aspect ratio
    const padding = 16;
  
    // Name Y: Vertically center with QR code + logo height below it
    // To do this, we'll stack: [QR | (Name, Logo under Name)]
    // Compute height: max(QR, nameHeight + logoHeight + spacing)
    // Let's allow name to be up to 2 lines, which means:
    const nameLines = 2;
    const nameHeight = nameFontSize * nameLineHeight * nameLines;
  
    // Calculate actual SVG size
    const rightColumnHeight = nameHeight + logoHeight + padding / 2;
    const svgHeight = Math.max(qrSize, rightColumnHeight) + padding;
    const svgWidth = qrSize + nameMaxWidth + 2 * padding;
  
    // X/Y positions
    const qrX = padding;
    const qrY = Math.round((svgHeight - qrSize) / 2);
    const nameX = qrX + qrSize + padding;
    const nameY = qrY; // Top-aligned to QR
    const logoX = qrSize/2 + 35;
    const logoY = 125;
  
    // Prepare logo
    const getImageBase64 = (url) =>
      fetch(url)
        .then((res) => res.blob())
        .then(
          (blob) =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            })
        );
    const logoDataUrl = await getImageBase64(odinLogo);
  
    // Compose SVG (no extra whitespace)
    const safeName = (name || "").replace(/[<>&]/g, "");
    const combinedSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="${svgHeight}">
    <g>
      <foreignObject x="${qrX}" y="${qrY}" width="${qrSize}" height="${qrSize}">
        ${qrSvg}
      </foreignObject>
      <foreignObject x="${nameX}" y="${nameY}" width="${nameMaxWidth}" height="${nameHeight}">
        <div xmlns="http://www.w3.org/1999/xhtml"
             style="font-family:Arial,sans-serif;font-size:${nameFontSize}px;font-weight:bold;
                    color:#222;word-break:break-word;line-height:${nameLineHeight};text-align:left;">
          ${safeName}
        </div>
      </foreignObject>
      <image x="${logoX}" y="${logoY}" width="${logoWidth}" height="${logoHeight}" href="${logoDataUrl}" />
    </g>
  </svg>
  `;
  
    // Download as SVG
    const blob = new Blob([combinedSvg], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const safeFile = safeName.replace(/[^a-z0-9_-]/gi, '_').toLowerCase();
  
    const link = document.createElement('a');
    link.href = url;
    link.download = `${safeFile}_qr.svg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  
    setTimeout(() => URL.revokeObjectURL(url), 500);
  };
  
  

  
  
  
  

  const renderFileUploadSection = (
    label,
    endpoint,
    stateArray,
    setStateArray,
    profileFiles = [],
    isImage = false,
    disableUpload = false
  ) => (
    <>
      <label>
        <span>{label}</span>
        {!disableUpload && (
          <input
            type="file"
            multiple
            accept={isImage ? 'image/*' : undefined}
            onChange={async (e) => {
              const files = [...e.target.files];
              const remainingImageSlots = Math.max(0, 5 - profileFiles.length);
              const maxFiles = isImage ? files.slice(0, remainingImageSlots) : files;
              if (isImage && files.length > remainingImageSlots) {
                alert(`Only ${remainingImageSlots} additional photo${remainingImageSlots === 1 ? '' : 's'} can be uploaded.`);
              }
              setStateArray(maxFiles);
              try {
                for (const file of maxFiles) {
                  const formData = new FormData();
                  formData.append('file', file);
                  await axios.post(
                    `/api/files/upload/${endpoint}?equipmentId=${equipmentId}`,
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }
                  );
                }
                await refreshProfile();
                e.target.value = '';
              } catch (error) {
                console.error(`Failed to upload ${label}:`, error);
                alert(`Failed to upload ${label.toLowerCase()}.`);
              }
            }}
          />
        )}
        {disableUpload && (
          <div className="hint">Uploads for this section are managed in the Inspection Record modal.</div>
        )}
      </label>
  
      {profileFiles.length > 0 && (
        isImage ? (
          <div className="file-preview-grid">
            {profileFiles.map((file, index) => (
              <div key={file.id ?? index} className="thumbnail">
                {file.filePath && (
                  <img src={resolveFileUrl(file.filePath)} alt={`Evidence ${index + 1}`} />
                )}
                <button
                  type="button"
                  className="file-delete"
                  onClick={() => handleDeleteDoc(endpoint, file)}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="file-list">
            {profileFiles.map((doc, index) => (
              <div className="file-item" key={doc.id ?? index}>
                <a
                  className="file-name"
                  href={resolveFileUrl(doc.filePath)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {doc.fileName?.trim() || doc.filePath?.split('/').pop() || `Document ${index + 1}`}
                </a>
                <button
                  type="button"
                  className="file-delete"
                  onClick={() => handleDeleteDoc(endpoint, doc)}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        )
      )}
    </>
  );
  const renderValveModal = () => (
  <div className="modal-overlay valve-editor-modal">
    <div className="modal-content valve-editor-dialog">
      <h3 className="valve-editor-title">{editingValve ? 'Edit Valve' : 'New Valve'}</h3>

      {/* REQUIRED */}
      <label><span>Valve Tag Number *</span>
        <input
          type="text"
          value={valveForm.valveTagNumber || ''}
          onChange={(e) => setValveForm({ ...valveForm, valveTagNumber: e.target.value })}
        />
      </label>

      {/* BASIC */}
      <label><span>Valve Location</span>
        <input
          type="text"
          value={valveForm.valveLocation || ''}
          onChange={(e) => setValveForm({ ...valveForm, valveLocation: e.target.value })}
        />
      </label>

      <label><span>SAP Number</span>
        <input
          type="text"
          value={valveForm.sapNumber || ''}
          onChange={(e) => setValveForm({ ...valveForm, sapNumber: e.target.value })}
        />
      </label>

      <label><span>Set Pressure</span>
        <input
          type="text"
          value={valveForm.setPressure || ''}
          onChange={(e) => setValveForm({ ...valveForm, setPressure: e.target.value })}
        />
      </label>

      <label><span>Test Frequency</span>
        <input
          type="text"
          value={valveForm.testFrequency || ''}
          onChange={(e) => setValveForm({ ...valveForm, testFrequency: e.target.value })}
        />
      </label>

      {/* TEST DATES */}
      <label><span>Last Test Date</span>
        <input
          type="date"
          value={valveForm.lastTestDate || ''}
          onChange={(e) => setValveForm({ ...valveForm, lastTestDate: e.target.value })}
        />
      </label>

      <label><span>Next Test Date</span>
        <input
          type="date"
          value={valveForm.nextTestDate || ''}
          onChange={(e) => setValveForm({ ...valveForm, nextTestDate: e.target.value })}
        />
      </label>

      {/* REPAIR/REPLACEMENT DATES (THE ONES YOU CALLED OUT) */}
      <label><span>Last Repair/Replacement</span>
        <input
          type="date"
          value={valveForm.lastRepairReplacement || ''}
          onChange={(e) => setValveForm({ ...valveForm, lastRepairReplacement: e.target.value })}
        />
      </label>

      <label><span>Next Repair/Replacement</span>
        <input
          type="date"
          value={valveForm.nextRepairReplacement || ''}
          onChange={(e) => setValveForm({ ...valveForm, nextRepairReplacement: e.target.value })}
        />
      </label>

      <label><span>Repair Frequency</span>
        <input
          type="text"
          value={valveForm.repairFrequency || ''}
          onChange={(e) => setValveForm({ ...valveForm, repairFrequency: e.target.value })}
        />
      </label>

      {/* SIZING / CAPACITY */}
      <label><span>Size</span>
        <input
          type="text"
          value={valveForm.size || ''}
          onChange={(e) => setValveForm({ ...valveForm, size: e.target.value })}
        />
      </label>

      <label><span>Required Capacity</span>
        <input
          type="text"
          value={valveForm.requiredCapacity || ''}
          onChange={(e) => setValveForm({ ...valveForm, requiredCapacity: e.target.value })}
        />
      </label>

      <label><span>Valve Capacity</span>
        <input
          type="text"
          value={valveForm.valveCapacity || ''}
          onChange={(e) => setValveForm({ ...valveForm, valveCapacity: e.target.value })}
        />
      </label>

      {/* DETAILS */}
      <label><span>Contents</span>
        <input
          type="text"
          value={valveForm.contents || ''}
          onChange={(e) => setValveForm({ ...valveForm, contents: e.target.value })}
        />
      </label>

      <label><span>Type</span>
        <input
          type="text"
          value={valveForm.type || ''}
          onChange={(e) => setValveForm({ ...valveForm, type: e.target.value })}
        />
      </label>

      <label><span>Manufacturer</span>
        <input
          type="text"
          value={valveForm.manufacturer || ''}
          onChange={(e) => setValveForm({ ...valveForm, manufacturer: e.target.value })}
        />
      </label>

      <label><span>Model Number</span>
        <input
          type="text"
          value={valveForm.modelNumber || ''}
          onChange={(e) => setValveForm({ ...valveForm, modelNumber: e.target.value })}
        />
      </label>

      <label><span>Serial Number</span>
        <input
          type="text"
          value={valveForm.serialNumber || ''}
          onChange={(e) => setValveForm({ ...valveForm, serialNumber: e.target.value })}
        />
      </label>

      <label><span>Flange Pressure Rating</span>
        <input
          type="text"
          value={valveForm.flangePressureRating || ''}
          onChange={(e) => setValveForm({ ...valveForm, flangePressureRating: e.target.value })}
        />
      </label>

      {/* NOTES (TEXT COLUMN) */}
      <label><span>Valve Notes</span>
        <textarea
          value={valveForm.valveNotes || ''}
          onChange={(e) => setValveForm({ ...valveForm, valveNotes: e.target.value })}
        />
      </label>

      {/* PHOTO PATH DISPLAY + UPLOAD */}
      <div style={{ marginTop: 10 }}>
        <div style={{ color: '#bbb', fontSize: 12, marginBottom: 6 }}>
          Photo Path: {valveForm.photoPath ? valveForm.photoPath : '(none)'}
        </div>

        {valveForm.photoPath && (
          <div style={{ marginBottom: 10 }}>
            <a
              href={resolveFileUrl(valveForm.photoPath)}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Current Photo
            </a>
          </div>
        )}

        <label>
          <span>Upload Valve Photo</span>
          <input
            type="file"
            accept="image/*"
            disabled={!editingValve?.id}
            onChange={async (e) => {
              const file = e.target.files?.[0];
              if (!file) return;
              try {
                await uploadValvePhoto(file, editingValve.id);
                // after refreshProfile, update form to show new photoPath
                const refreshed = await refreshProfile();
                const updated = (refreshed?.valves || []).find(x => String(x.id) === String(editingValve.id));
                if (updated) {
                  setEditingValve(updated);
                  setValveForm(prev => ({ ...prev, photoPath: updated.photoPath || prev.photoPath }));
                }
                e.target.value = '';
              } catch (err) {
                console.error(err);
                alert('Failed to upload valve photo.');
              }
            }}
          />
          {!editingValve?.id && (
            <div className="hint">Save the valve first before uploading a photo.</div>
          )}
        </label>
      </div>

      {/* INSPECTION DOCS UPLOAD (optional but usually wanted in same modal) */}
      <label style={{ marginTop: 10 }}>
  <span>Upload Valve Inspection Documents</span>
  <input
    type="file"
    multiple
    disabled={!editingValve?.id}
    onChange={async (e) => {
      const files = Array.from(e.target.files || []);
      if (!files.length) return;

      // open modal to collect display names per file
      openValveDocsUploadModal(files);

      // reset the input so selecting same file later triggers onChange
      e.target.value = '';
    }}
  />
  {!editingValve?.id && (
    <div className="hint">Save the valve first before uploading documents.</div>
  )}
</label>


      {/* EXISTING INSPECTION DOCUMENTS LIST */}
<div style={{ marginTop: 12 }}>
  <div style={{ fontWeight: 700, marginBottom: 8 }}>Valve Inspection Documents</div>

  {((editingValve?.inspectionDocuments || [])).length === 0 && (
    <div className="hint">No inspection documents uploaded for this valve yet.</div>
  )}

  {((editingValve?.inspectionDocuments || [])).length > 0 && (
    <div className="file-list">
      {(editingValve.inspectionDocuments || []).map((doc, idx) => (
        <div className="file-item" key={doc.id ?? idx} style={{ alignItems: 'center' }}>
          <a
            className="file-name"
            href={resolveFileUrl(doc.filePath)}
            target="_blank"
            rel="noopener noreferrer"
            style={{ flex: 1 }}
          >
            {(doc.displayName?.trim())
              ? doc.displayName.trim()
              : (doc.fileName?.trim() || doc.filePath?.split('/').pop() || `Document ${idx + 1}`)}
          </a>

          {/* Display Name editor */}
          <input
            type="text"
            placeholder="Display name (optional)"
            value={valveDocNameDrafts[doc.id] ?? (doc.displayName ?? '')}
            onChange={(e) =>
              setValveDocNameDrafts(prev => ({ ...prev, [doc.id]: e.target.value }))
            }
            style={{ width: 220, marginRight: 8 }}
          />

          <button
            className="save-btn inline"
            disabled={isSavingValveDocName}
            onClick={async () => {
              try {
                setIsSavingValveDocName(true);
                const displayName = (valveDocNameDrafts[doc.id] ?? '').trim();

                // backend endpoint we’ll add below
                await axios.put(`/api/valve-inspection-documents/${doc.id}/display-name`, {
                  displayName
                });

                const refreshed = await refreshProfile();
                const updated = (refreshed?.valves || []).find(x => String(x.id) === String(editingValve.id));
                if (updated) {
                  setEditingValve(updated);
                  // keep drafts in sync
                  const nextDrafts = {};
                  (updated.inspectionDocuments || []).forEach(d => {
                    if (d?.id) nextDrafts[d.id] = d.displayName ?? '';
                  });
                  setValveDocNameDrafts(nextDrafts);
                }
              } catch (err) {
                console.error(err);
                alert('Failed to update display name.');
              } finally {
                setIsSavingValveDocName(false);
              }
            }}
          >
            Save
          </button>

          <button
            className="file-delete"
            onClick={() => handleDeleteDoc('valveInspectionDocuments', doc)}
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  )}
</div>


      <div className="modal-actions valve-editor-actions">
        <button type="button" className="save-btn" onClick={saveValve}>
          {editingValve ? 'Update Valve' : 'Create Valve'}
        </button>
        <button
          type="button"
          className="cancel-btn"
          onClick={() => { setShowValveModal(false); setEditingValve(null); }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);


  

  const renderInspectionRecordModal = () => (
    <div className="modal-overlay">
      <div className="modal-content">
  
        <h3>{editingRecord ? 'Edit Inspection Record' : 'New Inspection Record'}</h3>
  
        <div className="modal-tabs">
  <button
    className={activeModalTab === 'details' ? 'active' : ''}
    onClick={() => setActiveModalTab('details')}
  >
    Record Details
  </button>

  <button
    className={activeModalTab === 'costs' ? 'active' : ''}
    onClick={handleCostsTabClick}
    title={!currentRecordId() ? 'Save Record Details first' : ''}
  >
    Costs
  </button>

  <button
    className={activeModalTab === 'documents' ? 'active' : ''}
    onClick={handleDocumentsTabClick}
    title={!currentRecordId() ? 'Save Record Details first' : ''}
  >
    Documents
  </button>
</div>


  
        {activeModalTab === 'details' && (
          <>
            <label><span>Date</span>
              <input
                type="date"
                value={newRecord.date}
                onChange={(e) => setNewRecord({ ...newRecord, date: e.target.value })}
              />
            </label>
  
            <label><span>Company</span>
              <input
                type="text"
                value={newRecord.company}
                onChange={(e) => setNewRecord({ ...newRecord, company: e.target.value })}
              />
            </label>
  
            <label><span>Inspector</span>
              <input
                type="text"
                value={newRecord.inspector}
                onChange={(e) => setNewRecord({ ...newRecord, inspector: e.target.value })}
              />
            </label>
  
            <label>
  <span>Type</span>
  <select
    value={newRecord.type || ''}
    onChange={(e) => setNewRecord({ ...newRecord, type: e.target.value })}
  >
    <option value="">Select type</option>
    {INSPECTION_TYPES.map(t => (
      <option key={t} value={t}>{t}</option>
    ))}
    {/* Show the current value if it's a legacy/non-standard one */}
    {!INSPECTION_TYPES.includes(newRecord.type) && newRecord.type && (
      <option value={newRecord.type}>{newRecord.type} (legacy)</option>
    )}
  </select>
</label>

  
            <label><span>Job Scope</span>
              <input
                type="text"
                value={newRecord.jobScope}
                onChange={(e) => setNewRecord({ ...newRecord, jobScope: e.target.value })}
              />
            </label>
            <label><span>Status</span>
              <input
                type="text"
                value={newRecord.status}
                onChange={(e) => setNewRecord({ ...newRecord, status: e.target.value })}
              />
            </label>
          </>
        )}
  
        {activeModalTab === 'costs' && (
          <>
            <label><span>Inspection Cost</span>
              <input
                type="number"
                value={inspectionCost.inspectionCost}
                onChange={(e) => setInspectionCost({ ...inspectionCost, inspectionCost: parseFloat(e.target.value) || 0 })}
              />
            </label>
  
            <label><span>Scaffold Cost</span>
              <input
                type="number"
                value={inspectionCost.scaffoldCost}
                onChange={(e) => setInspectionCost({ ...inspectionCost, scaffoldCost: parseFloat(e.target.value) || 0 })}
              />
            </label>
  
            <label><span>Cleaning Cost</span>
              <input
                type="number"
                value={inspectionCost.cleaningCost}
                onChange={(e) => setInspectionCost({ ...inspectionCost, cleaningCost: parseFloat(e.target.value) || 0 })}
              />
            </label>
  
            <label><span>Repair Cost</span>
              <input
                type="number"
                value={inspectionCost.repairCost}
                onChange={(e) => setInspectionCost({ ...inspectionCost, repairCost: parseFloat(e.target.value) || 0 })}
              />
            </label>
  
            <label><span>Notes</span>
              <textarea
                value={inspectionCost.notes}
                onChange={(e) => setInspectionCost({ ...inspectionCost, notes: e.target.value })}
              />
            </label>
          </>
        )}

{activeModalTab === 'documents' && (
  <>
    <label>
      <span>Upload Files</span>
      <input
        key={currentRecordId() ? `docs-${currentRecordId()}` : 'docs-disabled'}
        type="file"
        multiple
        disabled={!currentRecordId() || isUploadingRecDocs}
        onChange={async (e) => {
          const files = Array.from(e.target.files || []);
          if (!files.length) return;
          await uploadInspectionRecordDocs(files);
          // reset the input so selecting the same file again re-triggers change
          e.target.value = '';
        }}
      />
    </label>
    {!currentRecordId() && (
      <div className="hint">Save Record Details before uploading documents.</div>
    )}

    <div className="file-list" style={{ marginTop: 12 }}>
      {docsForCurrentRecord(currentRecordId())?.map((doc, i) => (
        <div className="file-item" key={doc.id ?? i}>
          <a
            className="file-name"
            href={resolveFileUrl(doc.filePath)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {doc.fileName?.trim() || doc.filePath?.split('/').pop() || `Document ${i + 1}`}
          </a>
          <button
            className="file-delete"
            onClick={() => handleDeleteDoc('inspectionRecordDocuments', doc)}
          >
            Delete
          </button>
        </div>
      ))}
      {docsForCurrentRecord(currentRecordId())?.length === 0 && (
        <div className="hint">No documents uploaded for this record yet.</div>
      )}
    </div>
  </>
)}



  
<div className="modal-actions">
  {activeModalTab !== 'documents' && (
    <button className="save-btn" onClick={handleSaveClick}>
      {activeModalTab === 'details'
        ? (editingRecord ? 'Update Details' : 'Create Record')
        : (inspectionCost?.id ? 'Update Costs' : 'Save Costs')}
    </button>
  )}
  <button
    className="cancel-btn"
    onClick={() => {
      setShowRecordModal(false);
      setSavedRecordId(null);
      setEditingRecord(null);
      setInspectionCost({
        id: 0,
        inspectionCost: 0,
        scaffoldCost: 0,
        cleaningCost: 0,
        repairCost: 0,
        notes: ''
      });
    }}
  >
    {activeModalTab === 'documents' ? 'Close' : 'Cancel'}
  </button>
</div>


      </div>
    </div>
  );
  const renderValveDocsUploadModal = () => (
  <div className="modal-overlay">
    <div className="modal-content">
      <h3>Valve Document Display Names</h3>

      {pendingValveDocs.length === 0 ? (
        <div className="hint">No files selected.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {pendingValveDocs.map((item) => (
            <div key={item.key} style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <div style={{ flex: 1, color: '#ddd', fontSize: 13 }}>
                {item.file?.name}
              </div>

              <input
                type="text"
                placeholder="Display name (optional)"
                value={item.displayName}
                onChange={(e) => {
                  const v = e.target.value;
                  setPendingValveDocs(prev =>
                    prev.map(x => x.key === item.key ? { ...x, displayName: v } : x)
                  );
                }}
                style={{ width: 260 }}
              />

              <button
                className="cancel-btn"
                disabled={isUploadingValveDocs}
                onClick={() => {
                  setPendingValveDocs(prev => prev.filter(x => x.key !== item.key));
                }}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="modal-actions" style={{ marginTop: 14 }}>
        <button
          className="save-btn"
          disabled={isUploadingValveDocs || pendingValveDocs.length === 0}
          onClick={uploadPendingValveDocs}
        >
          {isUploadingValveDocs ? 'Uploading...' : 'Upload All'}
        </button>

        <button
          className="cancel-btn"
          disabled={isUploadingValveDocs}
          onClick={() => {
            setShowValveDocsUploadModal(false);
            setPendingValveDocs([]);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);

  if (!isOpen || !profile || !profile.equipmentDescription) {
    return <div className="slide-out-loading">Loading...</div>;

  }

  // Merge fixed list + any existing/legacy covered process names from backend
  const coveredProcessOptions = [
    ...COVERED_PROCESS_OPTIONS,
    ...((profile.coveredProcesses || [])
      .map((p) => p.processName)
      .filter(
        (name) =>
          name &&
          !COVERED_PROCESS_OPTIONS.includes(name)
      )),
  ];

  const publicBaseUrl = process.env.REACT_APP_PUBLIC_BASE_URL || window.location.origin;
  const profileUrl = `${publicBaseUrl}/equipment/${equipmentId}/profile`;
  

  return (
    <div className={`slide-out full ${isOpen ? 'open' : ''}`}>
      <button className="close-btn" onClick={onClose}>✕</button>
      <div className="slide-content">
      <div className="header-with-photo">
  <h2>Edit Equipment Profile</h2>
  {profile?.designInformation?.photoPath && (
  <div className="design-photo-inline">
    <img
      src={resolveFileUrl(profile.designInformation.photoPath)}
      alt="Design Preview"
      onClick={() => setExpandedImage(resolveFileUrl(profile.designInformation.photoPath))}
      style={{ cursor: 'pointer' }}
    />
  </div>
)}

</div>

<div
  className={
    `section out-of-service-toggle` +
    (profile?.equipmentDescription?.outOfService ? ' active' : '')
  }
>
  <div className="out-of-service-toggle-header">
    <span className="out-of-service-title">Out of Service Status</span>
  </div>

  <div className="out-of-service-toggle-row">
    <label className="out-of-service-checkbox-label">
      <input
        type="checkbox"
        checked={!!profile.equipmentDescription?.outOfService}
        onChange={(e) =>
          setProfile((prev) => ({
            ...prev,
            equipmentDescription: {
              ...(prev.equipmentDescription || {}),
              outOfService: e.target.checked,
            },
          }))
        }
      />
      <span>
        {profile?.equipmentDescription?.outOfService
          ? 'Marked as OUT OF SERVICE'
          : 'Mark this asset as OUT OF SERVICE'}
      </span>
    </label>
  </div>

  {profile?.equipmentDescription?.outOfService && (
    <p className="out-of-service-helper">
      This asset is flagged as <strong>OUT OF SERVICE</strong>. It will be
      clearly highlighted on the read-only profile and should not be considered
      available for normal operation.
    </p>
  )}
</div>



<div className="section">
  <h3>General</h3>
  <label><span>Name</span>
    <input
      type="text"
      value={profile.equipmentDescription?.equipmentName || ''}
      onChange={(e) =>
        setProfile((prev) => ({
          ...prev,
          equipmentDescription: {
            ...(prev.equipmentDescription || {}),
            equipmentName: e.target.value,
          },
        }))
      }
      
    />
  </label>

  <label><span>Serial Number</span>
    <input
      type="text"
      value={profile.serialNumber || ''}
      onChange={(e) => setProfile({ ...profile, serialNumber: e.target.value })}
    />
  </label>

  <label><span>Area</span>
    <select
      value={profile.equipmentDescription?.areaId || ''}
      onChange={(e) =>
        setProfile((prev) => ({
          ...prev,
          equipmentDescription: {
            ...prev.equipmentDescription,
            areaId: e.target.value ? parseInt(e.target.value) : null,
          },
        }))
      }
    >
      <option value="">Select Area</option>
      {areas.map((area) => (
        <option key={area.id} value={area.id}>{area.name}</option>
      ))}
    </select>
  </label>
</div>


        <div className="section">
          <h3>Equipment Description</h3>
         

{Object.keys(profile.equipmentDescription || {}).map((key) =>
  !EXCLUDED_KEYS.has(key) && (
    <label key={key}>
      <span>{formatLabel(key)}</span>
      <input
        type="text"
        value={profile.equipmentDescription[key] ?? ''}
        onChange={(e) => handleInputChange('equipmentDescription', key, e.target.value)}
      />
    </label>
  )
)}
        </div>

        <div className="section">
  <h3>Next Inspections</h3>

  {NEXT_INSPECTION_FIELDS.map(({ label, dateKey, overrideKey }) => {
    const ed = profile?.equipmentDescription || {};
    const hasOverride = !!(ed[overrideKey] && String(ed[overrideKey]).trim().length);
    const mode = hasOverride ? 'override' : 'date';

    // Determine preset selection
    const overrideVal = (ed[overrideKey] ?? '').trim();
    const presetValue =
  OVERRIDE_PRESETS.includes(overrideVal) && overrideVal !== ''
    ? overrideVal
    : (overrideVal ? 'CUSTOM' : '');

    return (
      <div key={dateKey} style={{ borderTop: '1px solid #333', paddingTop: 12, marginTop: 12 }}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>{label}</div>

        <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
          <label className="checkbox-inline" style={{ marginRight: 12 }}>
            <input
              type="radio"
              name={`${dateKey}-mode`}
              checked={mode === 'date'}
              onChange={() => setNextInspectionMode(dateKey, overrideKey, 'date')}
            />
            <span>Date</span>
          </label>

          <label className="checkbox-inline">
            <input
              type="radio"
              name={`${dateKey}-mode`}
              checked={mode === 'override'}
              onChange={() => setNextInspectionMode(dateKey, overrideKey, 'override')}
            />
            <span>Special (EXEMPT / N/A / As Available / No Data)</span>
          </label>
        </div>

        {mode === 'date' ? (
          <label style={{ marginTop: 10 }}>
            <span>Date</span>
            <input
              type="date"
              value={ed[dateKey] ?? ''}
              onChange={(e) => setNextInspectionDate(dateKey, overrideKey, e.target.value)}
            />
          </label>
        ) : (
          <>
            <label style={{ marginTop: 10 }}>
              <span>Preset</span>
              <select
  value={presetValue}
  onChange={(e) => {
    const v = e.target.value;
    if (v === 'CUSTOM') {
      setNextInspectionOverride(dateKey, overrideKey, '');
    } else {
      setNextInspectionOverride(dateKey, overrideKey, v);
    }
  }}
>
  {OVERRIDE_PRESETS.map(o => (
    <option key={o} value={o}>{o}</option>
  ))}
</select>
            </label>

            {presetValue === 'CUSTOM' && (
              <label>
                <span>Custom Value</span>
                <input
                  type="text"
                  placeholder="e.g. As Available"
                  value={overrideVal}
                  onChange={(e) => setNextInspectionOverride(dateKey, overrideKey, e.target.value)}
                />
              </label>
            )}
          </>
        )}
      </div>
    );
  })}
</div>


       <div className="section">
  <h3>Design Information</h3>

  {DESIGN_INFO_FIELDS.map(({ key, label, type }) => {
    const val = profile?.designInformation?.[key];

    // boolean field
    if (type === 'boolean') {
      return (
        <label key={key}>
          <span>{label}</span>
          <select
            value={val === true ? 'true' : val === false ? 'false' : ''}
            onChange={(e) => {
              const v = e.target.value;
              handleInputChange('designInformation', key, v === '' ? null : v === 'true');
            }}
          >
            <option value="">(not set)</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </label>
      );
    }

    // string field
    return (
      <label key={key}>
        <span>{label}</span>
        <input
          type="text"
          value={val ?? ''}
          onChange={(e) => handleInputChange('designInformation', key, e.target.value)}
        />
      </label>
    );
  })}
</div>

         
        <div className="section">
        <h3>Covered Processes</h3>
        <div className="covered-processes-grid">
          {coveredProcessOptions.map((name) => {
            const checked =
              (profile.coveredProcesses || []).some(
                (p) => p.processName === name
              );

            return (
              <label key={name} className="checkbox-inline">
                <input
                  type="checkbox"
                  checked={!!checked}
                  onChange={(e) =>
                    handleCoveredProcessToggle(name, e.target.checked)
                  }
                />
                <span>{name}</span>
              </label>
            );
          })}
        </div>
      </div>


  <label>
    <span>Upload New Design Photo</span>
    <input
  type="file"
  accept="image/*"
  onChange={async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        await axios.post(`/api/files/upload/designPhoto?equipmentId=${equipmentId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 120000,
        });
        refreshProfile();
      } catch (error) {
        console.error('Upload failed:', error);
        alert('Failed to upload design photo. Please try again.');
      }
    }
  }}
/>


  </label>



        <div className="section">
  <h3>File Uploads</h3>

  {/* Design Documents */}
  <div className='file-upload-section'>
  {renderFileUploadSection(
  'Design Documents (multiple)',
  'designDocuments',
  designDocuments,
  setDesignDocuments,
  profile.designDocuments
)}
</div>

{/* Inspection Record Documents */}
<div className='file-upload-section'>
  {renderFileUploadSection(
    'Inspection Record Documents (multiple)',
    'inspectionRecordDocuments',
    inspectionRecordDocuments,
    setInspectionRecordDocuments,
    profile.inspectionRecordDocuments,
    false,
    true 
  )}
</div>

  {/* Vent & Overflow Documents */}
  <div className='file-upload-section'>
  {renderFileUploadSection(
  'Vent & Overflow Documents (multiple)',
  'ventOverflowDocuments',
  ventOverflowDocuments,
  setVentOverflowDocuments,
  profile.ventOverflowDocuments
)}
</div>


  {/* Inspection Protocol Documents */}
  <div className='file-upload-section'>
  {renderFileUploadSection(
  'Inspection Protocol Documents (multiple)',
  'inspectionProtocolDocuments',
  inspectionProtocolDocuments,
  setInspectionProtocolDocuments,
  profile.inspectionProtocolDocuments
)}
</div>

  {/* Tmin Calculation Documents */}
  <div className='file-upload-section'>
  {renderFileUploadSection(
  'Tmin Documents (multiple)',
  'tminDocuments',
  tminDocuments,
  setTminDocuments,
  profile.tminCalculationDocuments
)}
</div>

  {/* Additional Photos */}
<div className='file-upload-section'>
{renderFileUploadSection(
  'Additional Photos (max 5)',
  'additionalPhotos',
  additionalPhotos,
  setAdditionalPhotos,
  profile.additionalPhotos,
  true
)}
</div>
</div>




        <div className="section">
          <div className="section-header">
            <h3>Inspection Records</h3>
            <button className="save-btn inline" onClick={() => {
  setEditingRecord(null);
  setNewRecord({ date: '', company: '', inspector: '', type: '', jobScope: '', status: '' });
  setInspectionCost({
    id: 0,
    inspectionCost: 0,
    scaffoldCost: 0,
    cleaningCost: 0,
    repairCost: 0,
    notes: ''
  });
  setSavedRecordId(null); 
  setActiveModalTab('details');
  setShowRecordModal(true);
}}
>Add New Record</button>
          </div>

          <table className="data-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Company</th>
                <th>Inspector</th>
                <th>Type</th>
                <th>Job Scope</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {profile.inspectionRecords?.map((record, idx) => (
                <tr key={record.id} onClick={async () => {
                    setEditingRecord(record);
                    setSavedRecordId(String(record.id)); 
                    setNewRecord(buildRecordPayload(record));
                    setActiveModalTab('details'); 
                    setShowRecordModal(true);
                  
                    try {
                      const costRes = await axios.get(`/api/inspection-costs/equipment/${equipmentId}`);
                      const matched = costRes.data.find(
                        c => String(c.inspectionRecordId) === String(record.id)
                );
                      if (matched) {
                        setInspectionCost(matched);
                      } else {
                        setInspectionCost({
                          id: 0,
                          inspectionCost: 0,
                          scaffoldCost: 0,
                          cleaningCost: 0,
                          repairCost: 0,
                          notes: ''
                        });
                      }
                    } catch (err) {
                      console.error('Error fetching inspection cost:', err);
                    }
                  }}
                  >
                  <td>{record.date}</td>
                  <td>{record.company}</td>
                  <td>{record.inspector}</td>
                  <td>{record.type}</td>
                  <td>{record.jobScope}</td>
                  <td>{record.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showRecordModal && renderInspectionRecordModal()}  
         {showValveModal && renderValveModal()} 
         {showValveDocsUploadModal && renderValveDocsUploadModal()}      

        <div className="section">
  <div className="section-header">
    <h3>Valves</h3>
    <button className="save-btn inline" onClick={openNewValveModal}>
      Add Valve
    </button>
  </div>

  <table className="data-table">
    <thead>
      <tr>
        <th>Tag Number</th>
        <th>Set Pressure</th>
        <th>Test Freq</th>
        <th>Next Test</th>
        <th>Next Repair</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {(profile.valves || []).map((v) => (
        <tr key={v.id} onClick={() => openEditValveModal(v)} style={{ cursor: 'pointer' }}>
          <td>{v.valveTagNumber}</td>
          <td>{v.setPressure}</td>
          <td>{v.testFrequency}</td>
          <td>{v.nextTestDate || ''}</td>
          <td>{v.nextRepairReplacement || ''}</td>
          <td onClick={(e) => e.stopPropagation()}>
            <button className="cancel-btn" onClick={() => deleteValve(v.id)}>
              Delete
            </button>
          </td>
        </tr>
      ))}
      {(profile.valves || []).length === 0 && (
        <tr>
          <td colSpan="7" style={{ color: '#bbb' }}>
            No valves added yet.
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>


<div className="section">
  <div className="section-header">
    <h3>Action Items</h3>
    <button className="save-btn inline" onClick={handleOpenActionItemModal}>Add Action Item</button>
  </div>
          <table className="data-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Action Text</th>
                <th>Category</th>
                <th>Type</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Notes</th>
                <th>Completed</th>
              </tr>
            </thead>
            <tbody>
              {profile.actionItems?.map((item, idx) => (
                <tr
                key={idx}
                onClick={() => {
                  setEditingActionItem(item);
                  setNewActionItem({ ...item }); 
                  setShowActionItemModal(true);
                  }}
                  >
                  <td>{item.dueDate}</td>
                  <td>{item.actionText}</td>
                  <td>{item.category}</td>
                  <td>{item.type}</td>
                  <td>{item.priority}</td>
                  <td>{item.status}</td>
                  <td>{item.notes}</td>
                  <td>{item.completed ? 'Yes' : 'No'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showActionItemModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>{editingActionItem ? 'Edit Action Item' : 'New Action Item'}</h3>
              <label><span>Date</span><input type="date" value={newActionItem.dueDate} onChange={(e) => setNewActionItem({ ...newActionItem, dueDate: e.target.value })} /></label>
              <label><span>Action Text</span><input type="text" value={newActionItem.actionText} onChange={(e) => setNewActionItem({ ...newActionItem, actionText: e.target.value })} /></label>
              <label>
  <span>Category</span>
  <select
    value={newActionItem.category || ''}
    onChange={(e) => setNewActionItem({ ...newActionItem, category: e.target.value })}
  >
    <option value="">Select category</option>
    {ACTION_ITEM_CATEGORY.map((c) => (
      <option key={c} value={c}>{c}</option>
    ))}
    {/* keep legacy values selectable if the backend has older strings */}
    {newActionItem.category && !ACTION_ITEM_CATEGORY.includes(newActionItem.category) && (
      <option value={newActionItem.category}>{newActionItem.category} (legacy)</option>
    )}
  </select>
</label>

              <label>
  <span>Type</span>
  <select
    value={newActionItem.type || ''}
    onChange={(e) => setNewActionItem({ ...newActionItem, type: e.target.value })}
  >
    <option value="">Select type</option>
    {ACTION_ITEM_TYPE.map((t) => (
      <option key={t} value={t}>{t}</option>
    ))}
    {/* keep legacy values selectable if the backend has older strings */}
    {newActionItem.type && !ACTION_ITEM_TYPE.includes(newActionItem.type) && (
      <option value={newActionItem.type}>{newActionItem.type} (legacy)</option>
    )}
  </select>
</label>

              <label><span>Priority</span><input type="number" value={newActionItem.priority} onChange={(e) => setNewActionItem({ ...newActionItem, priority: parseInt(e.target.value) })} /></label>
              <label><span>Status</span><input type="text" value={newActionItem.status} onChange={(e) => setNewActionItem({ ...newActionItem, status: e.target.value })} /></label>
              <label><span>Notes</span><textarea value={newActionItem.notes}onChange={(e) =>setNewActionItem({ ...newActionItem, notes: e.target.value })}/></label>

              <label><span>Completed</span><input type="checkbox" checked={newActionItem.completed} onChange={(e) => setNewActionItem({ ...newActionItem, completed: e.target.checked })} /></label>
              <div className="modal-actions">
                <button className="save-btn" onClick={handleActionItemSubmit}>{editingActionItem ? 'Update' : 'Create'} Action Item</button>
                <button className="cancel-btn" onClick={() => setShowActionItemModal(false)}>Cancel</button>
              </div>
            </div>
          </div>
                 )}

                 {expandedImage && (
                   <div className="image-modal" onClick={() => setExpandedImage(null)}>
                     <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                       <button className="close-modal" onClick={() => setExpandedImage(null)}>✕</button>
                       <img src={expandedImage} alt="Expanded Preview" />
                     </div>
                   </div>
                 )}
         
                 <div className="actions">
                   <button onClick={handleProfileUpdate} className="save-btn">Save</button>
                   <button onClick={onClose} className="cancel-btn">Cancel</button>
                 </div>

                  {/* QR Code at the bottom */}
  <div style={{ width: '100%', marginTop: 24, textAlign: 'center' }}>
    
    <div
  style={{ width: '100%', marginTop: 32, textAlign: 'center', cursor: 'pointer' }}
  title="Download QR code"
  onClick={handleQrDownload}
>
  <div style={{ fontSize: 14, color: '#7cfa90', marginBottom: 6 }}>
    Scan to open this asset profile<br/>
    <span style={{ color: '#bbb', fontSize: 12 }}>(click to download)</span>
  </div>
  <QRCodeSVG
    id="equipment-qr"
    value={profileUrl}
    size={190}
    level="Q"
    bgColor="#fff"
    fgColor="#222"
  />
  <div style={{ fontSize: 11, color: '#bbb', marginTop: 4 }}>{profileUrl}</div>
</div>

  
  </div>
               </div>
             </div>

             
         

  
    
  );
};

export default AdminEquipmentProfileSlideOut;
